export default __webpack_public_path__ + "images/tw_end.png";